import { CustomIconProps } from './art';

export const GroupIcon = (props: CustomIconProps): JSX.Element => (
  <svg width="21" height="21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M11.223 12.469c.58 0 1.136.24 1.547.666.41.426.64 1.004.64 1.607l-.001 1.133c.15 2.783-1.913 4.17-5.738 4.17-3.812 0-5.921-1.369-5.921-4.13v-1.173c0-.603.23-1.181.64-1.607.41-.427.967-.666 1.547-.666h7.286zm5.833 0c.58 0 1.136.24 1.547.666.41.426.64 1.004.64 1.607v.798c.132 2.495-1.691 3.747-5.022 3.747-.452 0-.878-.023-1.274-.069.781-.751 1.2-1.77 1.198-3.057l-.008-.329.002-1.09c0-.907-.382-1.719-.988-2.273h3.905zm-9.473-9.09c.967 0 1.894.399 2.578 1.11a3.864 3.864 0 011.068 2.677 3.864 3.864 0 01-1.068 2.679 3.578 3.578 0 01-2.578 1.109c-.967 0-1.894-.4-2.578-1.11a3.864 3.864 0 01-1.068-2.678c0-1.004.385-1.967 1.068-2.678a3.578 3.578 0 012.578-1.11zm7.291 1.515c.774 0 1.516.32 2.063.887a3.09 3.09 0 01.854 2.143 3.09 3.09 0 01-.854 2.142 2.863 2.863 0 01-2.063.888c-.773 0-1.515-.32-2.062-.888a3.09 3.09 0 01-.854-2.142c0-.804.307-1.574.854-2.143a2.862 2.862 0 012.062-.887z"
        fill="#259BE9"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" transform="translate(0 .273)" d="M0 0h21v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
